import Title4 from './Title4';

export default Title4;
